import { Link } from "react-router-dom";
import { BlogPost } from "@/mocks/blog";

interface BlogCardProps {
  post: BlogPost;
}

export default function BlogCard({ post }: BlogCardProps) {
  const formattedDate = new Date(post.createdAt).toLocaleDateString("en-GB", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });

  return (
    <article className="bg-background-50 rounded-lg overflow-hidden group cursor-pointer transition-all duration-300 hover:bg-background-100 relative">
      <Link to={`/blog/${post.slug}`} className="block">
        {post.coverImage && (
          <div className="relative w-full h-48 md:h-52 overflow-hidden">
            <img
              src={post.coverImage}
              alt={post.title}
              className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
            />
          </div>
        )}
        <div className="p-5 md:p-6">
          <div className="flex items-center gap-3 mb-3">
            <span className="inline-block bg-accent-100 text-accent-800 font-label text-xs font-medium px-2.5 py-1 rounded-full">
              {post.category}
            </span>
            <span className="font-body text-xs text-foreground-500">{formattedDate}</span>
          </div>
          <h3 className="font-heading text-xl md:text-2xl font-medium text-foreground-950 mb-2 leading-snug group-hover:text-primary-600 transition-colors duration-300">
            {post.title}
          </h3>
          <p className="font-body text-sm text-foreground-600 leading-relaxed line-clamp-2">
            {post.excerpt}
          </p>
          {post.tags && post.tags.length > 0 && (
            <div className="mt-3 flex flex-wrap gap-1.5">
              {post.tags.map((tag) => (
                <span
                  key={tag}
                  className="inline-block bg-secondary-100 text-secondary-800 font-label text-[11px] font-medium px-2 py-0.5 rounded-full"
                >
                  {tag}
                </span>
              ))}
            </div>
          )}
          <div className="mt-4 flex items-center gap-1 font-body text-sm font-medium text-primary-600">
            Read more
            <i className="ri-arrow-right-line text-sm" />
          </div>
        </div>
      </Link>

      {/* Edit icon — sits top-right on the card */}
      <Link
        to={`/blog/admin/edit/${post.id}`}
        title="Edit this post"
        className="absolute top-3 right-3 w-8 h-8 flex items-center justify-center rounded-full bg-background-50/90 backdrop-blur-sm text-foreground-500 hover:text-foreground-950 hover:bg-background-100 transition-all duration-200 opacity-0 group-hover:opacity-100 cursor-pointer z-10"
      >
        <i className="ri-edit-line text-base" />
      </Link>
    </article>
  );
}